import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import { DisputeCategory, DisputeReason } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DisputeService {
  baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {
    this.baseUrl = this.appConfig.getconfig('disputeServiceUrl');
  }

  getDisputeCategoriesV1(tenantId: string): Observable<DisputeCategory[]> {
    return this.httpClient.get<DisputeCategory[]>(
      `${this.baseUrl}/v1/tenants/${tenantId}/categories`,
    );
  }

  getDisputeReasonsV1(tenantId: string): Observable<DisputeReason[]> {
    return this.httpClient.get<DisputeReason[]>(
      `${this.baseUrl}/v1/tenants/${tenantId}/reasons`,
    );
  }
}
